import { getAuth } from "firebase/auth";
import firebase from "../../settings/firebase";

export default getAuth(firebase);
